import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorProveedorService } from 'src/app/services/mantenedor-proveedor/mantenedor-proveedor.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { DialogCrearProveedor } from './crear-proveedor.component';
import { DialogEditaProveedor } from './edita-proveedor.component';



export interface DialogData 
{
    sexo: any
    estadoCivil: any
    regiones: any
    regionesDirDat: any
    comunas: any
    comunasDirDat: any
    roles: any
    recarga: boolean
    tipoAfiliado: any
    prevision: any
    sistemaSalud: any
}

@Component({
    selector: 'app-mantenedor-proveedor',
    templateUrl: '../../pages/mantenedor-proveedor/mantenedor-proveedor.component.html',
    styleUrls: ['../../pages/mantenedor-proveedor/mantenedor-proveedor.component.css']
})
export class MantenedorProveedorComponent implements OnInit {
    rol: string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    proveedores:any
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }
    allComplete: boolean = false
    usuarios: any
    usuariosFinales: any
    buscador: any = { correo: '', rut: '' }
    regiones:any
    comunas:any
    constructor(private dialog: MatDialog,
         private mantenedorProveedorService: MantenedorProveedorService) { }

    ngOnInit(): void {
        let vm = this
       
        vm.mostrarListaProveedoresSinFiltro();
    }
    mostrarListaProveedoresSinFiltro(){
        let vm = this
        this.mantenedorProveedorService.muestraListaProveedores(this.buscador).then
        (
            (listaProveedores: any) =>
            { 
            
            vm.proveedores = listaProveedores.resultado
            vm.buscador.paginasTotal = listaProveedores.resultado.length
            vm.config.currentPage = this.buscador.currentPage
            vm.config.totalItems = listaProveedores.cantidadRegistros
            this.buscador.rut = ''
            })             
      .catch
     (
         error =>
         {
             console.log("error",error)
             this.openAlertDialog('Ha ocurrido un error para buscar la lista de proveedores.', 'btn-danger')
         }
     )
    }
    crearProveedor() {

        let vm = this
        let data: any = {}

        const dialogRef = this.dialog.open(DialogCrearProveedor, { data: data,  disableClose: true, width: '40%' })
        dialogRef.afterClosed().subscribe(() => {
            if (data.recarga) {
              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                vm.usuariosFinales = []
               

            }
        })
    }
    buscar(){
        
        if(this.buscador.rut == ''){
            this.mostrarListaProveedoresSinFiltro();
        }
        this.mantenedorProveedorService.buscarProveedor(this.buscador.rut).then(
            (response : any)=>{
                
                this.proveedores = response.resultado
                this.buscador.paginasTotal = response.resultado.length
                this.config.currentPage = this.buscador.currentPage
                this.config.totalItems = response.cantidadRegistros
               
            }
            ).catch ( error =>
                {
                    console.log(error)
                      Swal.close();
                    this.openAlertDialog('No se han encontrado resultados.', 'btn-danger')
                } ) 

    }
    editarProveedor(idProveedor: any){
      
        let vm = this
        let data: any = {}
        this.mantenedorProveedorService.traeRegionesEspeciales().then(regiones => data.regiones = regiones).catch(error => console.log(error));
        this.mantenedorProveedorService.traeCantidadCuotas().then(cuota =>data.cuotas = cuota).catch(error => console.log(error))

        this.mantenedorProveedorService.traeCategoriaConvenio().then(response =>  data.categorias = response
            ).catch(error => console.log(error))
        this.mantenedorProveedorService.traeDatosProveedor(idProveedor).then(
            
            (proveedor : any)=>{
      
                {
                   
                    data.idProveedor= proveedor.idProveedor,
                    data.rutProveedor = proveedor.rutProveedor,
                    data.dvProveedor= proveedor.dvProveedor,
                    data.nombreCorto= proveedor.nombreCorto,
                    data.nombreProveedor = proveedor.nombreProveedor,
                    data.fechaEf = proveedor.fechaEf,
                    data.direccion = proveedor.direccion,
                    data.ciudad = proveedor.ciudad,
                    data.region = proveedor.region,
                    data.idRegion= proveedor.idRegion,
                    data.idComuna= proveedor.idComuna,
                   	data.rut = proveedor.rut,
                    data.idCategoria = proveedor.idCategoria,
                    data.idCuotas = proveedor.idCuotas,
                    data.regiones = data.regiones,
                    data.cuotas = data.cuotas,
                    data.categorias = data.categorias,
                    data.minCuotas = proveedor.minCuotas,
                    data.codigoFin = proveedor.pinNm,
                    data.rol = localStorage.getItem("rol"),
                    data.visibleConvenio = proveedor.visibleConvenio,
                    vm.mantenedorProveedorService.traeComunas(proveedor.idRegion).then(comunas => data.comunas = comunas).catch(error => console.log(error));

                }
          
                const dialogRef = this.dialog.open(DialogEditaProveedor, 
                    { data: data,  disableClose: true, width: '40%' })
                dialogRef.afterClosed().subscribe(() => { this.mostrarListaProveedoresSinFiltro();});
              
                vm.usuariosFinales = []
                this.buscador.rut = ''
            }
      
            
        )
         .catch ( error =>
            {
                console.log(error)
                  Swal.close();
                vm.openAlertDialog('Ha ocurrido un error para ver los datos del proveedor.', 'btn-danger')
            } )
        
    }
    modificarEstadoProveedor(idProveedor:any, estado:any){
        let vm = this

        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de cambiar el estado del Proveedor?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
              Swal.fire({
                allowOutsideClick:false,
                icon:'info',
                text:'Cargando...'
              });
              Swal.showLoading();
                if (estado == true) { estado = false }

                else { estado = true }
                
                vm.mantenedorProveedorService.modificarEstado(idProveedor, estado).then
                    (
                        () => {
                            vm.openAlertDialog("Se ha modificado exitosamente el estado del proveedor.", "btn-success")
                            Swal.close();
                            dialogRef.close()
                            this.mostrarListaProveedoresSinFiltro();
                            this.buscador.rut=''
                        }
                    )
                    .catch(error => {
                        console.log(error)

                        vm.openAlertDialog("Ha ocurrido un error al modificar el usuario.", "btn-danger")
                          Swal.close();
                        dialogRef.close()
                    })
                    
            }
        })
    }   
    

    updateAllComplete()
    {
        this.allComplete =  this.proveedores != null && this.proveedores
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }
    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent,
            {
                data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' } }
            })
    }

    pageChanged(event: any) {
        this.config.currentPage = event

        this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
        this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)
    }

    cambiaCantidadRegistros() {
        this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1
    }
   
}
  